module.exports = __webpack_public_path__ + "static/media/hotel.a6e37660.svg";